import React from 'react'
import { withIcon } from '../../withIcon'

function StopIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M16.3135 6H7.68651C6.75508 6 6 6.75507 6 7.6865V16.3135C6 17.2449 6.75508 18 7.68651 18H16.3135C17.2449 18 18 17.2449 18 16.3135V7.6865C18 6.75507 17.2449 6 16.3135 6Z" fill={color}/>
    </svg>
  )
}

export default withIcon(StopIcon)
